import "./audiomenu.scss";
import { type FC, useEffect, useState } from "react";
import { type IconProp } from "@fortawesome/fontawesome-svg-core";
import { useShopfrontDispatch, useShopfrontSelector } from "../../../_Bootstrap/hooks";
import { LAYOUT_AUDIO_TOGGLE } from "../../../Actions/General/LayoutActions";
import { fireEventType } from "../../../Utilities/Generic/ActionsHelper";
import AudioManager, { AudioManagerEvents, AudioTrackEvents } from "../../../Utilities/Platform/Audio/AudioManager";
import FontAwesomeLight from "../../../Utilities/Platform/FontAwesome/FontAwesomeLight";
import { AudioMenu } from "./AudioMenu";

const AudioIcon: FC = () => {
    const open = useShopfrontSelector(state => state.layout.audio.open);
    const dispatch = useShopfrontDispatch();

    const [ icon, setIcon ] = useState<IconProp>("volume");
    const [ audioReady, setAudioReady ] = useState(false);

    const onIconClick = () => {
        dispatch(fireEventType(LAYOUT_AUDIO_TOGGLE));
    };

    useEffect(() => {
        const audioManager = AudioManager.getInstance();

        if(audioManager.isReady()) {
            setAudioReady(true);

            return;
        }

        const listener = () => {
            setAudioReady(true);
        };

        audioManager.addListener(AudioManagerEvents.Ready, listener);

        return () => {
            audioManager.removeListener(AudioManagerEvents.Ready, listener);
        };
    }, []);

    useEffect(() => {
        if(!audioReady) {
            return;
        }

        const masterTrack = AudioManager.getInstance().getMasterTrack();

        const listener = () => {
            let icon: IconProp;

            if(masterTrack.isMuted()) {
                icon = "volume-mute";
            } else {
                const volume = masterTrack.getLevel();

                if(volume === 0) {
                    icon = "volume-off";
                } else if(volume < 0.33) {
                    icon = "volume-down";
                } else if(volume < 0.66) {
                    icon = "volume";
                } else {
                    icon = "volume-up";
                }
            }

            setIcon(icon);
        };

        listener();

        masterTrack.addListener(AudioTrackEvents.update, listener);

        return () => {
            masterTrack.removeListener(AudioTrackEvents.update, listener);
        };
    }, [ audioReady ]);

    let content;

    if(open) {
        content = (
            <AudioMenu />
        );
    }

    return (
        <div id="audio-container" className="header-item">
            <div id="audio-icon" onClick={onIconClick}>
                <FontAwesomeLight icon={icon} />
            </div>
            {content}
        </div>
    );
};

export default AudioIcon;
